var styleDataHash = "907f4c98";
const injectCss = () => {
  var css = `@charset "UTF-8";._6pOod,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.xUsYL{box-sizing:border-box;display:flex;flex-direction:column;gap:8px;max-height:360px;min-height:40px;overflow:hidden;overflow:auto}[dir] .xUsYL{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1));padding:8px 0}.xUsYL *,.xUsYL :after,.xUsYL :before{box-sizing:inherit}.xUsYL input{box-sizing:border-box}.H4jes{align-items:center;align-self:center;color:var(--ricos-settings-text-color,var(--ricos-text-color,#212121));display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:12px;justify-content:start;min-height:36px;width:220px}[dir] .H4jes{cursor:pointer}[dir=ltr] .H4jes{padding-left:12px;padding-right:8px}[dir=rtl] .H4jes{padding-left:8px;padding-right:12px}.H4jes span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir] .H4jes.TY-lY{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.H4jes .nVP-Q{height:28px;min-height:28px;min-width:28px;overflow:hidden;width:28px}[dir] .H4jes .nVP-Q{border-radius:50%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var mention_list_default = {
  "fontElementMap": "_6pOod",
  "mention_list": "xUsYL",
  "mention_item": "H4jes",
  "mention_item_selected": "TY-lY",
  "avatar": "nVP-Q"
};
export {
  mention_list_default as default,
  injectCss
};
//# sourceMappingURL=mention-list-scss.js.map
